module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main_wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0e8f2145"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/main_page.vue
// module id = 1237
// module chunks = 1